import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../../layouts/CommonLayout';
import useAuthStore from '../../../../store/authStore';
import { IoChevronForward } from 'react-icons/io5';
import { withdraw } from '../../../../api/MemberApi';
import { AlertModal } from '../../../layouts/AlertModal';
import { ConfirmModal } from '../../../layouts/ConfirmModal';

const SettingPage = () => {
  const navigate = useNavigate();
  const { logout, member } = useAuthStore();

  // 모달 상태 관리
  const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });
  const [confirmState, setConfirmState] = useState({ isVisible: false, title: '', message: '', onConfirm: () => {} });

  // 헬퍼 함수
  const showConfirm = (title, message, onConfirmAction) => {
    setConfirmState({
      isVisible: true,
      title,
      message,
      onConfirm: () => {
        onConfirmAction();
        setConfirmState({ ...confirmState, isVisible: false });
      }
    });
  };

  const getErrorMessage = (error) => {
    if (error.response && error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
  };

  const handleLogout = () => {
    showConfirm('로그아웃', '로그아웃 하시겠습니까?', () => {
      logout();
      navigate('/app');
    });
  };

  const handleWithdraw = async () => {
    const withdrawMessage = '정말 탈퇴하시겠습니까?\n탈퇴 시 모든 데이터가 삭제되며 복구할 수 없으며,\n탈퇴 후 일주일 동안 동일한 휴대폰 번호로 재가입할 수 없습니다.';

    showConfirm('회원 탈퇴', withdrawMessage, async () => {
      try {
        await withdraw();
        logout();
        setAlertState({
          isVisible: true,
          message: '회원 탈퇴가 완료되었습니다.',
          callback: () => navigate('/app', { replace: true })
        });
      } catch (error) {
        setAlertState({ isVisible: true, message: getErrorMessage(error) });
      }
    });
  };

  return (
      <CommonLayout title="설정">
        <AlertModal
            isVisible={alertState.isVisible}
            message={alertState.message}
            callback={alertState.callback}
            onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
        />
        <ConfirmModal
            isVisible={confirmState.isVisible}
            title={confirmState.title}
            message={confirmState.message}
            onConfirm={confirmState.onConfirm}
            onCancel={() => setConfirmState({ ...confirmState, isVisible: false })}
        />

        <div className="space-y-1">
          <button
              onClick={() => navigate('/app/settings/account-info')}
              className="w-full p-4 flex justify-between items-center active:bg-gray-50"
          >
            <span className="text-md">계정 정보</span>
            <IoChevronForward className="text-gray-400" />
          </button>

          {member?.provider === null && (
              <button
                  onClick={() => navigate('/app/settings/change-password')}
                  className="w-full p-4 flex justify-between items-center active:bg-gray-50"
              >
                <span className="text-md">비밀번호 변경</span>
                <IoChevronForward className="text-gray-400" />
              </button>
          )}

          <button
              onClick={() => navigate('/app/settings/phone-reverification')}
              className="w-full p-4 flex justify-between items-center active:bg-gray-50"
          >
            <span className="text-md">휴대폰 번호 재인증</span>
            <IoChevronForward className="text-gray-400" />
          </button>

          <button
              onClick={() => navigate('/app/settings/block-management')}
              className="w-full p-4 flex justify-between items-center active:bg-gray-50"
          >
            <span className="text-md">차단 밥친구 관리</span>
            <IoChevronForward className="text-gray-400" />
          </button>

          <button
              onClick={handleLogout}
              className="w-full p-4 flex justify-between items-center active:bg-gray-50 text-red-600"
          >
            <span className="text-md">로그아웃</span>
          </button>

          <button
              onClick={handleWithdraw}
              className="w-full p-4 flex justify-between items-center active:bg-gray-50 text-red-600"
          >
            <span className="text-md">탈퇴하기</span>
          </button>
        </div>
      </CommonLayout>
  );
};

export default SettingPage;
